import actions from '../actions/lodgingCancellationPolicyActions';

import createReducer from '../utils/createReducer';

// see graphql-lodging-policy type LodgingCancellationPolicy
export const initialState = {
    datesDoNotQualifyForCancellationText: '',
    freeCancellationLabel: null,
    cancellationPolicyLabel: {
        label: '',
        isFullRefundWindow: false
    },
    undatedPolicyText: '',
    policyText: null,
    undatedPolicyPeriodTexts: [],
    policyPeriodTexts: [],
    cancellationPolicyPeriods: [],
    nonRefundableFeeLabel: null
};

const actionHandlers = {
    [actions.UPDATE_LODGING_CANCELLATION_POLICY](_, {payload = {}}) {
        const {lodgingCancellationPolicy} = payload;
        return {...initialState, ...lodgingCancellationPolicy};
    }
};

export default createReducer(actionHandlers, initialState);
